"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoverOut = void 0;
class RecoverOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return RecoverOut.attributeTypeMap;
    }
}
exports.RecoverOut = RecoverOut;
RecoverOut.discriminator = undefined;
RecoverOut.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "BackgroundTaskStatus",
        "format": ""
    },
    {
        "name": "task",
        "baseName": "task",
        "type": "BackgroundTaskType",
        "format": ""
    }
];
//# sourceMappingURL=RecoverOut.js.map